module.exports = __webpack_public_path__ + "static/img/hat.3067f2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/hat.png
// module id = xij5
// module chunks = 0